<template>
  <div>
    <b-row>
      <b-col cols="12" md="6">
        <Endereco v-model="parceiro.pessoa_juridica.endereco" ref="endereco" />
      </b-col>
      <b-col cols="12" md="6">
        <h3>Telefone e Mídias Sociais</h3>
        <hr class="mt-0 mb-3" />
        <Contatos v-model="parceiro.pessoa_juridica.contatos" ref="contatos" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Endereco from "@/components/Form/Endereco.vue";
import Contatos from "@/components/Form/Contatos.vue";
import { mapState } from "vuex";

export default {
  components: { Endereco, Contatos },
  data: () => ({
    validations: {
      endereco: true,
      contatos: true,
    },
  }),

  computed: {
    ...mapState("parceiros", ["parceiro"]),
  },
  methods: {
    isValid() {
      this.validations.endereco = this.$refs.endereco.isValid();
      this.validations.contatos = this.$refs.contatos.isValid();

      return Object.values(this.validations).every(Boolean);
    },
  },
  created() {},
};
</script>

<style lang="scss"></style>
